module.exports = __webpack_public_path__ + "static/media/wop-map.7c28a7b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/digitalNomad/web-development/wop-map.png
// module id = 172
// module chunks = 0